/**
 * #228: every list filter has to answer the same question for its „Filter zurücksetzen" button —
 * is anything set that differs from what the page opened with? Each one compares a snapshot of
 * its own defaults, taken once in `ngOnInit`, against its current values.
 *
 * Dates compare by instant, and an empty text box counts as unset: a filter the user typed into
 * and cleared again is back to its default, not „filtered".
 */

function sameValue(a: unknown, b: unknown): boolean {
  if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
  if (a instanceof Date || b instanceof Date) return false;
  return empty(a) && empty(b) ? true : a === b;
}

function empty(value: unknown): boolean {
  return value === null || value === undefined || value === '';
}

/** Whether `current` still holds exactly the values of `defaults` — keys of both are compared. */
export function isDefaultFilter<T extends object>(current: T, defaults: T): boolean {
  const left = (current ?? {}) as Record<string, unknown>;
  const right = (defaults ?? {}) as Record<string, unknown>;
  for (const key of new Set([...Object.keys(left), ...Object.keys(right)])) {
    if (!sameValue(left[key], right[key])) return false;
  }
  return true;
}
